/*
 * File: OrderFormOptions.js
 * Project: mp-mobile-app
 *
 * Created by Rob Rothe
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Creates the arrays for the order form select fields
 */
import OrderReferences from "./OrderReferences";

class OrderFormOptions {
  /**
   * Fetches the order types and creates a new array of id,name to be used
   * for the order form select
   *
   * @return {Promise<Array>}
   */
  async getTypes(storeManager, isViewOnly) {
    const allTypes = await storeManager.getStore(OrderReferences).getTypes();

    if (isViewOnly) {
      return allTypes.map(orderType => ({
        id: orderType.typeId.toString(),
        name: orderType.type
      }));
    } else {
      return allTypes
        .filter(type => this.orderTypeAllowed(type))
        .map(orderType => ({
          id: orderType.typeId.toString(),
          name: orderType.type
        }));
    }
  }

  /**
   * Returns YES if the order type is allowed in order create/edit and NO if its not allowed
   *    Order types with an id over 110 are custom order types
   * @param {Array} fullTypesArray is an array of all order types
   */
  orderTypeAllowed(orderType) {
    let allowedIds = [1, 2, 3, 4, 100, 101, 102];
    return allowedIds.includes(orderType.typeId) || orderType.typeId > 110;
  }

  /**
   * Fetches the order statuses and creates a new array of id,name to be used
   * for the order form select
   *
   * @param {boolean} includeDefault
   * @return {Promise<Array>}
   */
  async getStatuses(storeManager, includeDefault = false) {
    let statuses = await storeManager.getStore(OrderReferences).getStatuses();
    let formData = [];
    statuses.forEach(t =>
      formData.push({
        id: t.orderStatusId.toString(),
        name: t.orderStatus
      })
    );
    return includeDefault
      ? this.getDefaultStatuses().concat(formData || [])
      : formData;
  }

  getDefaultStatuses() {
    return [
      {
        id: "0",
        name: "All Open"
      }
    ];
  }

  getSigned() {
    return [
      {
        id: "1",
        name: "Unsigned"
      },
      {
        id: "2",
        name: "Signed"
      }
    ];
  }
}

const newStore = new OrderFormOptions();
export default newStore;
